import type { FaireProductEntity } from "../../entity_types/product";

export const p_86bu8a8hue: FaireProductEntity = {
  token: "p_86bu8a8hue",
  type: "product",
  name: "Halloween squishies case of 10",
  brandToken: "b_h5gjyp96qt",
  brandName: "Majestic mailers",
  imageUrl:
    "https://cdn.faire.com/fastly/efef1ff90500671e794ef6f0930cab226f6d6f8f5dc36a37e7149abb5303adeb.jpeg",
  galleryImageUrls: [],
  priceDollars: 80,
  description:
    "These cute Halloween squishies are sure to be your next best seller \n\nSlow rebound and individually packaged \n\nEach case comes with 10 mixed colors ",
  tags: [],
  msrpDollars: 160,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:34.134Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
